import mifosRepository, { MifosRepository } from "./MifosRepository";
import { ContentTypes } from "../../utils/ContentTypes";
import EzUtils from "../../utils/EzUtils";

const resource = "";
export default {
  createDocument(entityType, entityId, name, description, subDirectory, file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file, EzUtils.getFileNameWithTimestamp(file));
      formData.append("name", name);
      formData.append("description", description);
      formData.append("subDirectory", subDirectory);

      mifosRepository.setContentType(ContentTypes.MULTIPART_FORM_DATA);
      MifosRepository.post(`${resource}/${entityType}/${entityId}/documents`, formData)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateDocument(
    entityType,
    entityId,
    documentId,
    comments,
    name,
    description,
    verificationStatus,
    file
  ) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      if (file) {
        formData.append("file", file, EzUtils.getFileNameWithTimestamp(file));
      }
      if (name) {
        formData.append("name", name);
      }
      if(description) {
        formData.append("description", description);
      }
      if (comments) {
        formData.append("comments", comments);
      }
      if(verificationStatus) {
        formData.append("verificationStatus", verificationStatus);
      }

      mifosRepository.setContentType(ContentTypes.MULTIPART_FORM_DATA);
      MifosRepository.put(
        `${resource}/${entityType}/${entityId}/documents/${documentId}`,
        formData
      )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  removeDocument(entityType, entityId, documentId) {
    mifosRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return MifosRepository.delete(`${entityType}/${entityId}/documents/${documentId}`);
  },

  getDocuments(entityType, entityId) {
    mifosRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return MifosRepository.get(`${resource}/${entityType}/${entityId}/documents`);
  },

  createDocumentLocation(entityType, entityId, name, description, fileName, fileLocation) {
    mifosRepository.setContentType(ContentTypes.APPLICATION_JSON);
    const query = `?name=${name}&&description=${description}&&fileName=${fileName}&&fileLocation=${fileLocation}`;
    return MifosRepository.post(`${resource}/${entityType}/${entityId}/documents/metadata${query}`);
  }
};
